<template>
  <footer
    class="flex-shrink-0 z-40 bg-charcoal-900 text-white py-2 sm:py-4 border-t border-charcoal-700 shadow-lg"
  >
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between gap-2 sm:gap-4">
        <!-- Left: Copyright (compact on mobile) -->
        <div class="text-sm text-charcoal-300 whitespace-nowrap">
          <span>&copy; {{ currentYear }}</span>
          <span class="hidden sm:inline"> Site Compass Pty Ltd</span>
        </div>

        <!-- Center: Links (hidden on mobile) -->
        <a
          href="https://www.sitecompass.net"
          target="_blank"
          rel="noopener noreferrer"
          class="hidden sm:flex text-sm text-charcoal-300 hover:text-white transition-colors duration-200 items-center gap-1"
        >
          <span>Visit Site Compass</span>
          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
            />
          </svg>
        </a>

        <!-- Right: Version + Env indicator + AI Orb -->
        <div class="flex items-center gap-2">
          <button
            type="button"
            class="text-sm text-charcoal-400 font-mono hover:text-white transition-colors duration-200 px-2 sm:px-3 py-1 sm:py-1.5 rounded-lg hover:bg-white/10 cursor-pointer whitespace-nowrap"
            title="Click to view what's new"
            @click="openChangelog"
          >
            <span class="hidden sm:inline text-charcoal-500">v</span>{{ version }}
            <span class="text-charcoal-600 mx-0.5 sm:mx-1">|</span>
            <span class="hidden sm:inline text-charcoal-500">build </span>{{ buildNumber }}
          </button>
          <!-- Teleport target for collapsed EnvironmentIndicator -->
          <span id="env-indicator-slot" class="inline-flex items-center" />
          <!-- AI Chat Orb (context-driven visibility, inline flex child) -->
          <AiOrbButton v-if="aiChat.isEnabled" @click="aiChat.open()" />
        </div>
      </div>
    </div>

    <!-- Changelog Dialog -->
    <ChangelogDialog ref="changelogDialog" />
  </footer>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import ChangelogDialog from './ChangelogDialog.vue'
import AiOrbButton from '@/components/ai-chat/AiOrbButton.vue'
import { useAiChatContextStore } from '@/stores/ai-chat-context.store'
// Import version data - this will be replaced at build time
import versionData from '../../../../version.json'

const aiChat = useAiChatContextStore()
const changelogDialog = ref<InstanceType<typeof ChangelogDialog> | null>(null)

const currentYear = computed(() => new Date().getFullYear())
const version = computed(() => versionData.version)
const buildNumber = computed(() => versionData.buildNumber)

const openChangelog = () => {
  changelogDialog.value?.open()
}
</script>
